/**
 * @generated SignedSource<<3e79a6353954530226203a79355ef761>>
 * @relayHash 96a357ea6bf7d6e6b974939dcdb1935d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b310b99e34ec25ad16ee0f3f3047867a76ffcc43641ca09c70485a9bc1021faa

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardQuery } from './src_jiraBusinessBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b310b99e34ec25ad16ee0f3f3047867a76ffcc43641ca09c70485a9bc1021faa",
    "metadata": {},
    "name": "src_jiraBusinessBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
